import React, { useEffect, useState, useCallback } from "react";
import VideoContainer from "../../videos_container/VideoContainer";
import videoService from "../../../../services/videos";
import { notify, debounce } from "../../../../utils/helper";
import { ModalWrapper } from "../videos/styled";
import { CustomSearchContainer } from "../../../table-item";
import { Row, Col, Input, Pagination, Spin } from "antd";
import { FiSearch } from "react-icons/fi";
import Filter from "../../../table-item/filter/Filter";
import { CustomSecondaryButton } from "../../physician_page/styled";

const AttachSecriptModal = ({
  open,
  setOpen,
  selectedRecording,
  recordingFileUrl,
  recordingFileName,
  getRecordingFileFromS3,
  handleOpenModal,
}) => {
  const [videos, setVideos] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
    total: 0,
  });
  const [videoSpecialtyList, setVideoSpecialtyList] = useState([]);
  const [filterTab, setFilterTab] = useState([]);
  const [sortingColumn, setSortingColumn] = useState("");
  const [myVideosLoadMoreLoading, setMyVideosLoadMoreLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [myVideosCurrentPage, setMyVideosCurrentPage] = useState(1);
  const [myVideosHasMore, setMyVideosHasMore] = useState(true);
  const [allVideos, setAllVideos] = useState([]);
  const myVideoPageSize = 9;

  const handleCancel = () => {
    setOpen(false);
  };

  const getAllVideos = async (
    page = 1,
    searchInput = searchText,
    isLoadMore = false
  ) => {
    try {
      if (isLoadMore) {
        setMyVideosLoadMoreLoading(true);
      } else {
        setIsLoading(true);
      }
      const res = await videoService.getVideos(
        myVideoPageSize,
        page,
        sortingColumn,
        searchInput,
        JSON.stringify(filterTab),
        "",
        "",
        ""
      );
      const newVideo = res?.data?.videos?.results || [];
      if (isLoadMore) {
        setAllVideos((prev) => [...prev, ...newVideo]);
        setVideos(res?.data?.videos);
      } else {
        setAllVideos(newVideo);
        setVideos(res?.data?.videos);
      }
      setMyVideosHasMore(newVideo.length === myVideoPageSize);
      setMyVideosCurrentPage(page);
    } catch (err) {
      // console.log(err);
      setIsLoading(false);
    } finally {
      if (isLoadMore) {
        setMyVideosLoadMoreLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    setMyVideosCurrentPage(1);
    setAllVideos([]);
    getAllVideos(1, searchText, false);
  }, [filterTab]);

  const handleSearch = useCallback(
    debounce((value) => {
      setMyVideosCurrentPage(1);
      setAllVideos([]);
      getAllVideos(1, value, false);
    }, 500),
    []
  );

  const getAllVideoSpecialty = async () => {
    try {
      const res = await videoService.getVideos(0, 1, "", "", "", "", "", "");
      const uniqueNames = [
        ...new Set(res?.data?.videos?.results?.map((item) => item?.specialty).filter(Boolean)),
      ];
      setVideoSpecialtyList(uniqueNames);
    } catch (error) {}
  };

  useEffect(() => {
    getAllVideoSpecialty();
  }, []);

  const handleMyVideosLoadMore = () => {
    const nextPage = myVideosCurrentPage + 1;
    getAllVideos(nextPage, searchText, true);
  };

  return (
    <ModalWrapper
      styles={{ body: { height: "500" } }}
      title={
        <h3 className="font-18 font-semibold text-primary">
          Clone Audio
          </h3>
      }
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={900}
    >
      <div>
        <Col
          span={24}
          className="d-flex mb-15"
          style={{ justifyContent: "space-between" }}
        >
          <div className="d-flex  gap-12" style={{ width: "100%" , justifyContent:'start'}}>
            <CustomSearchContainer>
              <FiSearch
                style={{ position: "absolute", zIndex: 1 }}
                className="icon ml-5"
              />
              <Input
                style={{paddingLeft: "25px"}}
                placeholder="Search here..."
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  handleSearch(e.target.value);
                }}
              />
            </CustomSearchContainer>


            {/* <div> */}
            <Filter
              show={show}
              setShow={setShow}
              data={[
                {
                  title: "Specialty",
                  list: videoSpecialtyList,
                  filterList: filterTab,
                  setFilterList: setFilterTab,
                },
              ]}
            />
            {/* </div> */}
          </div>
        </Col>
        {allVideos?.length > 0 ? (
          <>
            <VideoContainer
              isAttachRecording
              videos={{ ...videos, results: allVideos }}
              selectedRecording={selectedRecording}
              recordingFileUrl={recordingFileUrl}
              recordingFileName={recordingFileName}
              getRecordingFileFromS3={getRecordingFileFromS3}
              setOpen={setOpen}
              handleOpenModal={handleOpenModal}
              onlyMasterVideo={true}
            />
            {myVideosHasMore && (
              <Col
                className="mt-25 w-100 d-flex justify-content-center"
                style={{ padding: "20px 0" }}
              >
                <CustomSecondaryButton
                  onClick={handleMyVideosLoadMore}
                  loading={myVideosLoadMoreLoading}
                >
                  Load More Videos
                </CustomSecondaryButton>
              </Col>
            )}
            {!myVideosHasMore && allVideos.length > 0 && (
              <Col
                className="mt-25 w-100 d-flex justify-content-center"
                style={{ padding: "20px 0" }}
              >
                <p style={{ color: "#666", fontStyle: "italic" }}>
                  No more videos to load
                </p>
              </Col>
            )}
          </>
        ) : isLoading ? (
          <div
            className="mt-25 w-100 d-flex justify-content-center"
            style={{ height: "400px", alignItems: "center" }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <div className="mt-25 w-100 d-flex justify-content-center">
            No Videos
          </div>
        )}
      </div>
    </ModalWrapper>
  );
};

export default AttachSecriptModal;
